interface IPushLoginEventProps {
  id: string;
}

export function pushMenuCLickEvent({ id }: IPushLoginEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "menu_click",
      id,
    });
  }
}
